import { render, staticRenderFns } from "./ImportTranslationsModal.vue?vue&type=template&id=5a6433ec&scoped=true&"
import script from "./ImportTranslationsModal.vue?vue&type=script&lang=js&"
export * from "./ImportTranslationsModal.vue?vue&type=script&lang=js&"
import style0 from "./ImportTranslationsModal.vue?vue&type=style&index=0&id=5a6433ec&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6433ec",
  null
  
)

export default component.exports